import { render } from "./YummablePage.vue?vue&type=template&id=ddddc92c"
const script = {}

import "./YummablePage.vue?vue&type=style&index=0&id=ddddc92c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__